import HeaderFormInvestment from './HeaderFormInvestment';
export default HeaderFormInvestment;
